module.exports = __webpack_public_path__ + "img/107053.d1aacc2c.png";